import React, {useEffect, useRef} from 'react';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/SearchRounded';
import {
    Collapse,
    IconButton,
    InputAdornment,
    List,
    ListItem,
    ListItemText,
    TextField,
} from '@mui/material';

const VehiclesDropdownAutoSelect = ({
    label,
    listToggle,
    handleListToggle,
    setSearchText,
    open,
    vehicleOptions,
    handleClick,
    handleVehicleChange,
    prohibitedVehicleList,
    removeProhibitedVehicle,
    disabled,
    regulationText,
    handleMultipleVehicleChanges,
    removedAutoSuggestedVehiclesRef,
    hasParsedRegulationTextRef
}: any) => {

    const autoAddedVehiclesRef = useRef<Set<string>>(new Set());
const prevRegulationTextRef = useRef<string | null>(null);

useEffect(() => {
    if (
        !regulationText ||
        !vehicleOptions ||
        !prohibitedVehicleList ||
        hasParsedRegulationTextRef.current ||
        regulationText === prevRegulationTextRef.current // :white_check_mark: Skip if text didn't change
    ) return;

    prevRegulationTextRef.current = regulationText; // :white_check_mark: Save current for next comparison

    const debounceTimer = setTimeout(() => {
        const normalizedText = regulationText.toLowerCase();
        const vehiclesToAutoAdd: string[] = [];

        vehicleOptions.forEach(({ items }: any) => {
            items.forEach(({ key }: any) => {
                const normalizedKey = key.trim().toLowerCase();
                const shouldAdd =
                    normalizedText.includes(normalizedKey) &&
                    !prohibitedVehicleList.includes(key) &&
                    !removedAutoSuggestedVehiclesRef.current.has(key);

                if (shouldAdd) {
                    autoAddedVehiclesRef.current.add(key);
                    vehiclesToAutoAdd.push(key);
                }
            });
        });

        if (vehiclesToAutoAdd.length > 0) {
            handleMultipleVehicleChanges(vehiclesToAutoAdd);
        }

        hasParsedRegulationTextRef.current = true;
    }, 300);

    return () => clearTimeout(debounceTimer);
}, [regulationText, vehicleOptions, prohibitedVehicleList]); 
    

    return (
        <>
            <div style={{ margin: '12px 0px', fontSize: '12px' }}>{label}</div>
            <TextField
                style={{ width: '50%', marginRight: '20px', height: '64px' }}
                variant="standard"
                autoComplete='off'
                placeholder="Write name here to add"
                type="text"
                onChange={(e) => {
                    setSearchText(e.target.value);
                }}
                InputLabelProps={{ style: { fontSize: '14px' } }}
                onFocus={handleListToggle}
                disabled={disabled}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
            />
            {listToggle ? (
                <List component="nav" style={{ width: '50%' }}>
                    {vehicleOptions.map(({ key, label, items }: any) => {
                        const isOpen = open[key] || false;
                        return (
                            <div key={key}>
                                <ListItem button onClick={() => handleClick(key)}>
                                    <ListItemText primary={label} />
                                    {isOpen ? <ExpandLess /> : <ExpandMore />}
                                </ListItem>
                                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {items.map(({ key: childKey, label: childLabel }: any) => (
                                            <ListItem key={childKey} button>
                                                <ListItemText
                                                    inset
                                                    primary={childLabel}
                                                    onClick={(e: any) => {
                                                        handleVehicleChange(childKey);
                                                    }}
                                                />
                                            </ListItem>
                                        ))}
                                    </List>
                                </Collapse>
                            </div>
                        );
                    })}
                </List>
            ) : (
                <></>
            )}
            <div style={{ marginTop: '24px', display: 'flex', flexWrap: 'wrap' }}>
                {prohibitedVehicleList &&
                    prohibitedVehicleList.length > 0 &&
                    prohibitedVehicleList.map((vehicle: string, index: number) => (
                        <div className="amenityIconBox" key={index}>
                            <span style={{ margin: '5px', textTransform: 'capitalize' }}>
                                {vehicle}
                            </span>
                            <IconButton
                                onClick={() => {
                                    removeProhibitedVehicle(vehicle);
                                }}
                                style={{ padding: '0px' }}
                                disabled={disabled}
                            >
                                <CloseIcon />
                            </IconButton>
                        </div>
                    ))}
            </div>
        </>
    );
};

export default VehiclesDropdownAutoSelect;
